import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { UPD_PROJECT, DELETE_PROJECT } from "../../../../queries";

import * as Ionicons from "react-icons/io";
import { Button, Modal, ModalBody } from "reactstrap";
import DeleteModal from "./DeleteModalBody";
import DeleteModalBody from "./DeleteModalBody";
import { useUserInfo } from "../../../../Layout/AppMain/LoginStatusContext";

/**
 * 事業大項目のテーブルヘッドコンポーネント
 * @param data
 * @returns
 */

const ProjectTitle = (data: any) => {
  const { ability } = useUserInfo();
  // 定款事業削除
  // 220731 commentout
  // TO DO: 上部のプロジェクト削除時にuseStateの値が保持される問題あり
  // const [dltProject] = useMutation(DELETE_PROJECT, {
  //   update(cache, { data: { rmProject } }) {
  //     cache.modify({
  //       fields: {
  //         allProject(exisitingAct, { readField }) {
  //           return exisitingAct.edges.filter(
  //             (pj: any) => rmProject.project.id !== readField("id", pj)
  //           );
  //         },
  //       },
  //     });
  //   },
  // });
  // const deleteProject = async (pjId: any) => {
  //   await dltProject({
  //     variables: {
  //       orgId: data.orgId,
  //       userId: data.userId,
  //       projectId: data.projectId,
  //     },
  //   });
  //   await deleteProjectModalToggle();
  // };
  // 定款事業削除確認モーダル
  const [deleteProjectModal, setDeleteProjectModal] = useState(false);
  const deleteProjectModalToggle = () =>
    setDeleteProjectModal(!deleteProjectModal);

  // 定款事業更新
  const [editProjectTitle, setEditProjectTitle] = useState(false);
  const [projectTitile, setProjectTitle] = useState(data.projectTitle);
  const [updProject] = useMutation(UPD_PROJECT);
  const editProject = async (_pjId: any) => {
    await updProject({
      variables: { project_id: _pjId, title: projectTitile },
    });
    setEditProjectTitle(!editProjectTitle);
  };
  const Arrow = Ionicons["IoIosArrowDroprightCircle"];
  const CloseIcon = Ionicons["IoIosClose"];

  return (
    <div className="py-4">
      <>
        <h6
          className="m-0 p-0 ema__text ema__flex ema__space_between"
          style={{ flexDirection: "row" }}
        >
          <div>
            <Arrow
              color="link"
              className="text-left m-0 p-0 pointer"
              onClick={() => data.toggleAccordion(data.i)}
              aria-expanded={true}
              aria-controls={data.accordion[data.i]}
              style={{
                display: "inline",
                transform: data.accordion[data.i] ? "rotate(90deg)" : "",
              }}
            />
            {data.myPage && ability == "can_edit" && editProjectTitle ? (
              <>
                <input
                  className="p-2 mx-2 ema__newbiz"
                  placeholder="新規事業カテゴリ"
                  value={projectTitile}
                  onChange={(e) => setProjectTitle(e.target.value)}
                />
                <>
                  <Button
                    className="ema__btn__sm_update mx-2"
                    onClick={(e) => editProject(data.projectId)}
                  >
                    更新
                  </Button>

                  <CloseIcon
                    fontSize="17px"
                    onClick={(e) => {
                      setEditProjectTitle(!editProjectTitle);
                    }}
                  />
                </>
              </>
            ) : (
              <>
                <span
                  className="pl-2"
                  onClick={() => data.toggleAccordion(data.i)}
                >
                  {data.projectTitle}
                </span>
                {data.myPage && ability == "can_edit" && (
                  <span
                    onClick={() => {
                      setEditProjectTitle(!editProjectTitle);
                    }}
                    className="lnr lnr-pencil pointer ml-2 ema__color__blue"
                  ></span>
                )}
              </>
            )}
          </div>
          {/* 削除ボタン 220731 comment out */}
          {/* {data.myPage && ability == "can_edit" ? (
            editProjectTitle ? (
              <></>
            ) : (
              <div>
                <span
                  className="lnr lnr-trash ml-2 pointer ema__color__red"
                  onClick={(e) => deleteProjectModalToggle()}
                >
                  {data[2]}
                </span>
                <Modal
                  isOpen={deleteProjectModal}
                  toggle={deleteProjectModalToggle}
                >
                  <DeleteModalBody
                    deleteFunc={deleteProject}
                    deleteObjTitle={projectTitile}
                  />
                </Modal>
              </div>
            )
          ) : (
            <></>
          )} */}
        </h6>
      </>
    </div>
  );
};

export default ProjectTitle;
